module.exports = __webpack_public_path__ + "static/media/west_bengal.96ecc234.png";